// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".favourite-container[data-v-5f2b2934]{position:absolute;top:10px;right:45px}", ""]);
// Exports
module.exports = exports;
